// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/provider-widget/provider-widget.less
// module id = 3053
// module chunks = 0